import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {},
    wrapper: {
      display: 'flex',
      [theme.fn.smallerThan('sm')]: {
        alignItems: 'center',
        padding: rem(8),
        gap: rem(16),
        img: {
          width: rem(48),
        },
      },
      [theme.fn.largerThan('sm')]: {
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${rem(12)} ${rem(12)} ${rem(24)}`,
        gap: rem(24),
      },
    },
    thumbnail: {
      borderRadius: rem(16),
      [theme.fn.smallerThan('sm')]: {
        width: rem(120),
      },
    },
    heading: { textAlign: 'center' },
  }
})
